import axios from 'axios'

export default {
  getParams(domain) {
    return axios.get(`https://${domain}/themes/params`)
  },
}
